import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  organization: string;
  phone?: string;
  inquiryType: string;
  message: string;
  turnstileToken: string;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private apiUrl = environment.contactApiUrl;

  constructor(private http: HttpClient) { }

  submitContactForm(data: ContactFormData): Observable<ContactFormResponse> {
    return this.http.post<ContactFormResponse>(this.apiUrl, data)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An error occurred while submitting the form.';
    
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = 'Network error occurred. Please check your internet connection.';
    } else {
      // Server-side error
      switch (error.status) {
        case 0:
          errorMessage = 'Unable to connect to the server. Please check your internet connection.';
          break;
        case 400:
          errorMessage = error.error?.message || 'Invalid form data. Please check your inputs.';
          break;
        case 403:
          errorMessage = 'Security verification failed. Please try again.';
          break;
        case 429:
          errorMessage = 'Too many requests. Please wait a moment and try again.';
          break;
        case 500:
        case 502:
        case 503:
          errorMessage = 'Server error. Please try again in a few moments.';
          break;
        case 504:
          errorMessage = 'Request timeout. Please try again.';
          break;
        default:
          errorMessage = error.error?.message || `Server error (${error.status}). Please try again.`;
      }
    }
    
    console.error('Contact form submission error:', error);
    return throwError(() => new Error(errorMessage));
  }
}

